import { render, staticRenderFns } from "./Trainer.vue?vue&type=template&id=11505a8a&"
import script from "./Trainer.vue?vue&type=script&lang=js&"
export * from "./Trainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports